import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Input from '../../components/Form/Input';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import '../../assets/styles/account/account.scss';
import { useTranslation } from "react-i18next";

export default function Registration() {
    const { t } = useTranslation();
    const schema = yup.object().shape({
        email: yup.string()
            .required(t('login.errors.required'))
            .matches(/^((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))|((.+)?([1-9][0-9][0-9]{7}))$/,
                {message: t('login.errors.email')})
            .test(
                'accountExists',
                t('login.errors.accountExists'),
                async (value, context) => await (await fetch('/rest/account/registration/checkAccountJson', {
                    method: 'POST',
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    body: JSON.stringify({email: value})
                })).json() === true
            ),
        password: yup.string()
            .required(t('login.errors.required'))
            .min(6, t('login.errors.passwordMinLength'))
            .max(16, t('login.errors.passwordMaxLength')),
        speciality: yup.string().required(),
        iAmDoctor: yup.boolean().required().oneOf([true]),
        personalData: yup.boolean().required().oneOf([true]),
        userAgreement: yup.boolean().required().oneOf([true]),
    });
    const referer = false;
    const {register, handleSubmit, watch, errors} = useForm(
        {
            resolver: yupResolver(schema),
            mode: 'onBlur',
            reValidateMode: 'onBlur',
            defaultValues: {
                iAmDoctor: false,
                personalData: false,
                userAgreement: false,
            }
        }
    );
    const onSubmit = data => console.log(data);
    const [showPassword, setShowPassword] = useState(false);
    const [specialties, setSpecialties] = useState([]);

    useEffect(() => {
         fetch("/api/v1/spa/dictionaries/medicalSpecialties")
            .then(res => res.json())
            .then(
                (result) => {
                    setSpecialties(result);
                },
            )
    }, [])

    return (
        <section className="section flex-center">
            <div className="authentication-form registration-form">
                <h1>{t('registration.header')}</h1>
                <form id="registrationForm" onSubmit={handleSubmit(onSubmit)}>
                    <div className="login-socials-block">
                        <button className="facebook-btn" type="button"
                                onClick={() => window.location.href = '/connect/facebook'}>{t('buttons.facebookLogin')}
                        </button>
                        <button className="google-btn" type="button"
                                onClick={() => window.location.href = '/connect/google'}>{t('buttons.googleLogin')}
                        </button>
                    </div>
                    {referer && <input type="hidden" name="referrer" value={referer}/>}
                    <div className="form-group block-static-height js-form-group">
                        <Input type="text" name="email"
                               id="emailRegistration" register={register}
                               inputClassName="form-input"
                               labelClassName="form-label"
                               label="registration.labels.username"
                               autoComplete="off"
                               watch={watch}
                        />
                        { errors.email ? <span className="error_text">{errors.email.message}</span> :
                            <span className="info-text">{t('registration.labels.usernameDescription')}</span> }
                    </div>
                    <div className="form-group block-static-height js-form-group">
                        <Input type={showPassword ? "text" : "password" }
                               name="password"
                               id="passwordRegistration" register={register({required: true})}
                               inputClassName="form-input"
                               labelClassName="form-label"
                               label="registration.labels.password"
                               autoComplete="off"
                               watch={watch}
                        />
                        { errors.password ? <span className="error_text">{t('registration.errors.wrongPasswordFormat')}</span> :
                            <span className="info-text">{t('registration.password.description')}</span>}
                        <div className="hide-show-link">
                            { showPassword ?
                                <span className="js-hide-password-text" onClick={() => setShowPassword(false)}>{t('registration.password.hide')}</span> :
                                <span className="js-show-password-text" onClick={() => setShowPassword(true)}>{t('registration.password.show')}</span>
                            }
                        </div>
                    </div>
                    <div className="form-group block-static-height select-block js-form-group">
                        <select id="speciality" name="speciality" ref={register} className="form-select">
                            <option value=""></option>
                            {specialties.map((specialty) => <option value={specialty.id}>{specialty.name}</option>)}
                        </select>
                        <label htmlFor="speciality"
                               className="form-label select-label">{t('registration.labels.specialty')}</label>
                        { errors.speciality && <span className="error_text">{t('registration.errors.incorrectData')}</span> }
                    </div>
                    <div className="form-group check-group js-form-group">
                        <input ref={register} defaultChecked={false} className="magic-checkbox" type="checkbox" name="iAmDoctor" id="iAmDoctor"/>
                        <label htmlFor="iAmDoctor">
                            {t('registration.labels.isDoctor')}
                            { errors.iAmDoctor && <span className="js-error error-check"/> }
                        </label>
                    </div>
                    <div className="form-group check-group js-form-group">
                        <input ref={register} defaultChecked={false}  className="magic-checkbox" type="checkbox" name="personalData"
                               id="personalData"
                        />
                        <label dangerouslySetInnerHTML={{__html: t('registration.labels.privacyAgreement')}}  htmlFor="personalData">
                        </label>
                        { errors.personalData && <span className="js-error error-check"/> }
                    </div>
                    <div className="form-group check-group js-form-group">
                        <input ref={register} defaultChecked={false} className="magic-checkbox" type="checkbox" name="userAgreement"
                               id="userAgreement" />
                        <label htmlFor="userAgreement">
                            <a target="_blank" href="/static/documents/document.pdf"
                               className="label-link">{t('registration.labels.termsAgreement')}</a>
                            { errors.userAgreement && <span className="js-error error-check"/> }
                        </label>
                    </div>
                    <div className="submit-block">
                        <input type="submit" value={t('buttons.registration')}
                               className="btn"/>
                    </div>
                    <div className="login-link-block">
                        <a rel="login-form" href="/login"
                           className="inline-block js-link-to-form">{t('login.login')}</a>
                    </div>
                </form>
            </div>
        </section>
    );
}
